(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["style-it-together"] && !Shopify.designMode) return;
  try {
    
(function () {
  const root = document.querySelector('[data-wf-bundle]');
  if (!root) return;
  const mainPrice = parseFloat(root.dataset.mainPrice) || 0;
  const mainVariant = root.dataset.mainVariant;
  const totalEl = root.querySelector('[data-wf-bundle-total]');
  const btn = root.querySelector('[data-wf-add-bundle]');
  const hintEl = root.querySelector('[data-wf-hint]');
  const scrollEl = root.querySelector('[data-wf-tier-scroll]');
  const companions = Array.from(root.querySelectorAll('[data-wf-companion]'));
  const tiers = Array.from(root.querySelectorAll('[data-wf-tier]'));
  const unlockedSet = new Set();
  let initialized = false;  // 2026-05-09: gate user-triggered effects (scrollIntoView + animation)

  const tierMeta = [
    { id: '1', name: 'Cashmere Care Comb' },
    { id: '2', name: 'Free Shipping' },
    { id: '3', name: '20% Off' },
    { id: '4', name: 'Silk Scrunchie' },
    { id: '5', name: '$20 Gift Card' },
    { id: '6', name: 'Silk Eye Mask' }
  ];

  function fmtMoney(n) {
    return '$' + n.toFixed(2).replace(/\.00$/, '');
  }

  function getSelected() {
    let total = mainPrice;
    let count = 1;
    const variants = [{ id: mainVariant, quantity: 1 }];
    companions.forEach(row => {
      const checkbox = row.querySelector('.wf-bundle__check--input');
      if (checkbox && checkbox.checked) {
        const price = parseFloat(row.dataset.price) || 0;
        const vid = row.dataset.variantId;
        total += price;
        count += 1;
        variants.push({ id: vid, quantity: 1 });
      }
    });
    return { total, count, variants };
  }

  function updateHint(total, count) {
    const hierarchy = [
      { type: 'amount', threshold: 55,  name: 'Cashmere Care Comb' },
      { type: 'amount', threshold: 100, name: 'Free Shipping' },
      { type: 'amount', threshold: 220, name: '20% Off' },
      { type: 'amount', threshold: 200, name: 'Silk Scrunchie' },
      { type: 'amount', threshold: 250, name: '$20 Gift Card' },
      { type: 'amount', threshold: 300, name: 'Silk Eye Mask' }
    ];
    const next = hierarchy.find(t =>
      (t.type === 'amount' && total < t.threshold) ||
      (t.type === 'count'  && count < t.threshold)
    );
    if (!next) {
      hintEl.innerHTML = 'All <strong>6 rewards</strong> unlocked ✓';
    } else {
      const gap = next.type === 'amount'
        ? 'add <strong>' + fmtMoney(next.threshold - total) + '</strong> more'
        : 'add <strong>' + (next.threshold - count) + '</strong> more item';
      hintEl.innerHTML = gap + ' → unlock <strong>' + next.name + '</strong>';
    }
  }

  function checkUnlocks(total, count) {
    tiers.forEach(card => {
      const threshold = parseFloat(card.dataset.threshold);
      const type = card.dataset.type;
      const tid = card.dataset.wfTier;
      const meets = (type === 'amount' && total >= threshold) ||
                    (type === 'count'  && count >= threshold);
      if (meets && !unlockedSet.has(tid)) {
        unlockedSet.add(tid);
        card.classList.add('is-unlocked');
        if (initialized) {
          // user-triggered unlock — animate + scroll + confetti
          card.classList.add('is-just-unlocked');
          setTimeout(() => card.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' }), 100);
          if (window.confetti) {
            setTimeout(() => {
              const rect = card.getBoundingClientRect();
              window.confetti({
                particleCount: 32, spread: 50, startVelocity: 22,
                ticks: 100, gravity: 0.7, scalar: 0.7,
                origin: {
                  x: (rect.left + rect.width / 2) / window.innerWidth,
                  y: (rect.top + rect.height / 2) / window.innerHeight
                },
                colors: ['#9d5248', '#b89968', '#ede7dc', '#c47a6d']
              });
            }, 350);
          }
          setTimeout(() => card.classList.remove('is-just-unlocked'), 1500);
        }
      } else if (!meets && unlockedSet.has(tid)) {
        unlockedSet.delete(tid);
        card.classList.remove('is-unlocked', 'is-just-unlocked');
        if (initialized) {
          // Scroll back to next target tier (lowest-threshold still locked)
          setTimeout(() => {
            const nextTier = Array.from(root.querySelectorAll('[data-wf-tier]'))
              .find(c => !unlockedSet.has(c.dataset.wfTier));
            if (nextTier) nextTier.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
          }, 200);
        }
      }
    });
  }

  function refresh() {
    const { total, count } = getSelected();
    if (totalEl) totalEl.textContent = fmtMoney(total);
    updateHint(total, count);
    checkUnlocks(total, count);
  }

  // Companion checkbox listeners
  companions.forEach(row => {
    const cb = row.querySelector('.wf-bundle__check--input');
    if (cb) cb.addEventListener('change', refresh);
  });

  // Add bundle button — POST to /cart/add.js
  btn.addEventListener('click', async function () {
    const { variants } = getSelected();
    btn.disabled = true;
    btn.querySelector('.wf-bundle__btn-label').textContent = 'Adding...';
    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: variants.map(v => ({ id: parseInt(v.id), quantity: v.quantity })) })
      });
      if (!res.ok) throw new Error('Add failed: ' + res.status);
      // Trigger Horizon cart drawer refresh
      document.documentElement.dispatchEvent(new CustomEvent('cart:update', { bubbles: true }));
      document.documentElement.dispatchEvent(new CustomEvent('cart-drawer:open', { bubbles: true }));
      // Fallback — try common Horizon events
      window.dispatchEvent(new Event('cart:refresh'));
      btn.querySelector('.wf-bundle__btn-label').textContent = 'Added ✓';
      setTimeout(() => {
        btn.querySelector('.wf-bundle__btn-label').textContent = btn.dataset.defaultLabel || 'Add to bag';
        btn.disabled = false;
      }, 1500);
    } catch (e) {
      console.error('[wf-bundle]', e);
      btn.querySelector('.wf-bundle__btn-label').textContent = 'Try again';
      btn.disabled = false;
    }
  });

  // Lazy-load confetti CDN (optional — graceful degrade if blocked)
  if (!window.confetti) {
    const s = document.createElement('script');
    s.src = 'https://cdn.jsdelivr.net/npm/canvas-confetti@1.9.2/dist/confetti.browser.min.js';
    s.async = true;
    document.head.appendChild(s);
  }

  // Initial state — set unlocked flags WITHOUT animation/scroll/confetti, then mark initialized
  // so that subsequent user-triggered changes (checkbox click) do animate.
  setTimeout(() => {
    const t1 = root.querySelector('[data-wf-tier="1"]');
    if (scrollEl && t1) {
      scrollEl.scrollLeft = t1.offsetLeft - (scrollEl.clientWidth - t1.clientWidth) / 2;
    }
    refresh();           // initialized=false → skips scrollIntoView / animations
    initialized = true;  // any future refresh from user input will now animate
  }, 100);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wf-recently-viewed"] && !Shopify.designMode) return;
  try {
    
(function(){
  var KEY = 'wf_recent_v1';
  var host = document.currentScript && document.currentScript.previousElementSibling;
  function init(){
    var el = document.querySelector('wf-recent');
    if(!el) return;
    var ds = el.dataset;
    var list = [];
    try { list = JSON.parse(localStorage.getItem(KEY) || '[]'); } catch(e){ list = []; }
    // 渲染历史(排除当前)
    var grid = el.querySelector('[data-wf-recent-grid]');
    var others = list.filter(function(i){ return i && i.handle && i.handle !== ds.handle; }).slice(0, 8);
    if (others.length){
      grid.innerHTML = others.map(function(i){
        return '<a class="wf-rv-card" href="'+i.url+'"><span class="wf-rv-ph"><img src="'+i.img+'" alt="" loading="lazy"></span><span class="wf-rv-nm">'+i.title+'</span><span class="wf-rv-pr">'+i.price+'</span></a>';
      }).join('');
      grid.hidden = false;
    }
    // 存当前(去重, 置顶, cap 12)
    var next = list.filter(function(i){ return i && i.handle !== ds.handle; });
    next.unshift({ handle: ds.handle, title: ds.title, price: ds.price, img: ds.img, url: ds.url });
    try { localStorage.setItem(KEY, JSON.stringify(next.slice(0, 12))); } catch(e){}
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wf-style"] && !Shopify.designMode) return;
  try {
    
(function(){
  if (window.__wfCollabInit) return;
  window.__wfCollabInit = true;

  function qvEls(){
    return {
      scrim: document.querySelector('[data-wf-qv-scrim]'),
      qv: document.querySelector('[data-wf-qv]'),
      imgs: document.querySelector('[data-wf-qv-imgs]'),
      title: document.querySelector('[data-wf-qv-title]'),
      price: document.querySelector('[data-wf-qv-price]'),
      sub: document.querySelector('[data-wf-qv-sub]'),
      feats: document.querySelector('[data-wf-qv-features]'),
      atc: document.querySelector('[data-wf-qv-atc]'),
      full: document.querySelector('[data-wf-qv-full]'),
      msg: document.querySelector('[data-wf-qv-msg]')
    };
  }
  var cur = null;

  function safeParse(s, fb){ try { return JSON.parse(s); } catch(e){ return fb; } }

  function open(ds){
    var e = qvEls();
    if(!e.qv) return;
    cur = ds;
    var imgs = safeParse(ds.imgs, []);
    e.imgs.innerHTML = imgs.slice(0,6).map(function(u){ return '<img src="'+u+'" alt="" loading="lazy">'; }).join('') || '';
    e.title.textContent = ds.title || '';
    e.price.innerHTML = ds.price || '';
    e.sub.textContent = ds.sub || '';
    // 4 function (about_features metafield)
    var feats = safeParse(ds.features, null);
    var arr = [];
    if (feats && Array.isArray(feats)) arr = feats;
    else if (feats && Array.isArray(feats.value)) arr = feats.value;
    e.feats.innerHTML = arr.slice(0,4).map(function(f){
      var t = f.title || f.heading || '';
      var d = f.desc || f.description || f.text || '';
      return '<li>' + (t ? '<b>'+t+'</b>' : '') + d + '</li>';
    }).join('');
    e.feats.style.display = arr.length ? 'grid' : 'none';
    e.full.href = ds.url || '#';
    e.atc.textContent = 'Add to bag';
    e.atc.classList.remove('is-done');
    e.msg.textContent = '';
    e.scrim.hidden = false; e.qv.hidden = false;
    requestAnimationFrame(function(){ e.scrim.classList.add('is-open'); e.qv.classList.add('is-open'); });
    document.documentElement.style.overflow = 'hidden';
  }
  function close(){
    var e = qvEls();
    if(!e.qv) return;
    e.scrim.classList.remove('is-open'); e.qv.classList.remove('is-open');
    document.documentElement.style.overflow = '';
    setTimeout(function(){ if(e.scrim) e.scrim.hidden = true; if(e.qv) e.qv.hidden = true; }, 320);
  }

  function openCartDrawer(){
    var cd = document.querySelector('cart-drawer-component') || document.querySelector('cart-drawer') || document.querySelector('[data-cart-drawer]');
    if (cd){
      if (typeof cd.open === 'function') { cd.open(); return true; }
      if (typeof cd.showDialog === 'function') { cd.showDialog(); return true; }
      var dlg = cd.querySelector('dialog'); if (dlg && typeof dlg.showModal === 'function'){ dlg.showModal(); return true; }
    }
    return false;
  }

  function addToBag(){
    var e = qvEls();
    if(!cur || !cur.vid) return;
    e.atc.textContent = 'Adding…';
    fetch('/cart/add.js', {
      method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'},
      body: JSON.stringify({ items:[{ id: Number(cur.vid), quantity:1 }] })
    }).then(function(r){ return r.json(); }).then(function(){
      e.atc.textContent = '✓ Added';
      e.atc.classList.add('is-done');
      // Horizon: dispatch 'cart:update'(ThemeEvents.cartUpdate) → cart-items 自己 renderSection 刷新内容 + cart-icon 更新计数
      document.dispatchEvent(new CustomEvent('cart:update', { bubbles:true }));
      setTimeout(function(){
        var opened = openCartDrawer();
        if (opened) { close(); }
        else { e.msg.innerHTML = 'Added to your bag &nbsp;·&nbsp; <a href="/cart" style="text-decoration:underline">View bag</a>'; }
      }, 350);
    }).catch(function(){ e.atc.textContent = 'Add to bag'; e.msg.textContent = 'Something went wrong — try again.'; });
  }

  document.addEventListener('click', function(ev){
    var trig = ev.target.closest('.wf-qv-trigger');
    if (trig){ ev.preventDefault(); open(trig.dataset); return; }
    if (ev.target.closest('[data-wf-qv-close]') || ev.target.matches('[data-wf-qv-scrim]')){ close(); return; }
    if (ev.target.closest('[data-wf-qv-atc]')){ addToBag(); return; }
  });
  document.addEventListener('keydown', function(ev){ if (ev.key === 'Escape') close(); });
})();

  } catch(e) { console.error(e); }
})();
})();
